"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledRow = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 0 2rem;\n  margin-bottom: ", ";\n"])), function (p) {
  return p.isHowToPlayAboveBanner ? "0" : "2.5rem";
});

var StyledColumn = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  flex: 1 1 50%;\n  text-align: ", ";\n  padding: ", ";\n"])), function (props) {
  return props.isLeft ? "right" : "left";
}, function (props) {
  return props.isLeft ? "0 2rem 0 0" : "0 0 0 2rem";
});

var StyledLogoWrapper = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 110px;\n  text-align: center;\n"])));

var StyledFixtureLogo = _styledComponents.default.img(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  height: 90px;\n  max-width: 113px;\n"])));

var StyledVs = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 2rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorLabel;
});

var StyledClubName = (0, _styledComponents.default)(_fiverReactUiComponents.ClubName)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 110%;\n  left: 50%;\n  line-height: 1.25;\n  white-space: nowrap;\n  max-width: 110px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transform: translateX(-50%);\n  text-align: center;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding-bottom: 0.5rem;\n"])));

var ContestBannerFixture = function ContestBannerFixture(_ref) {
  var _match$homeTeam, _match$homeTeam2, _match$homeTeam3, _match$awayTeam, _match$awayTeam2, _match$awayTeam3;

  var isHowToPlayAboveBanner = _ref.isHowToPlayAboveBanner,
      activePickem = _ref.activePickem;
  var match = (activePickem === null || activePickem === void 0 ? void 0 : activePickem.footballMatch) || (activePickem === null || activePickem === void 0 ? void 0 : activePickem.sportMatch);
  var homeTeamName = match === null || match === void 0 ? void 0 : (_match$homeTeam = match.homeTeam) === null || _match$homeTeam === void 0 ? void 0 : _match$homeTeam.name;
  var homeTeamLogo = (match === null || match === void 0 ? void 0 : (_match$homeTeam2 = match.homeTeam) === null || _match$homeTeam2 === void 0 ? void 0 : _match$homeTeam2.logoImg) || (match === null || match === void 0 ? void 0 : (_match$homeTeam3 = match.homeTeam) === null || _match$homeTeam3 === void 0 ? void 0 : _match$homeTeam3.logo);
  var awayTeamName = match === null || match === void 0 ? void 0 : (_match$awayTeam = match.awayTeam) === null || _match$awayTeam === void 0 ? void 0 : _match$awayTeam.name;
  var awayTeamLogo = (match === null || match === void 0 ? void 0 : (_match$awayTeam2 = match.awayTeam) === null || _match$awayTeam2 === void 0 ? void 0 : _match$awayTeam2.logoImg) || (match === null || match === void 0 ? void 0 : (_match$awayTeam3 = match.awayTeam) === null || _match$awayTeam3 === void 0 ? void 0 : _match$awayTeam3.logo);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledRow, {
    isHowToPlayAboveBanner: isHowToPlayAboveBanner,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumn, {
      isLeft: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLogoWrapper, {
        children: [!homeTeamLogo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonWidth: "90px",
          skeletonHeight: "90px",
          skeletonBorderRadius: "20px"
        }), homeTeamLogo && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFixtureLogo, {
          src: homeTeamLogo
        }), homeTeamName && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
          isAbbreviated: true,
          children: homeTeamName
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledVs, {
      children: [homeTeamLogo && awayTeamLogo && "vs", !homeTeamLogo && !awayTeamLogo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
        skeletonWidth: "20px",
        skeletonHeight: "16px",
        skeletonBorderRadius: "0.25rem"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledColumn, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledLogoWrapper, {
        children: [!awayTeamLogo && /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.Skeleton, {
          skeletonWidth: "90px",
          skeletonHeight: "90px",
          skeletonBorderRadius: "20px"
        }), awayTeamLogo && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFixtureLogo, {
          src: awayTeamLogo
        }), awayTeamName && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
          children: awayTeamName
        })]
      })
    })]
  });
};

var _default = ContestBannerFixture;
exports.default = _default;